import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-box" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = { class: "modal-footer" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(['modal-container', _ctx.halfScreen ? 'half-screen' : _ctx.fullScreen ? 'full-screen' : _ctx.mostScreen ? 'most-screen' : ''])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(['row1', _ctx.halfScreen ? 'half-screen' : _ctx.fullScreen ? 'full-screen' : _ctx.mostScreen ? 'most-screen' : ''])
            }, [
              _renderSlot(_ctx.$slots, "header-text"),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("i", {
                  class: "fal fa-times-circle close-icon",
                  onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('close')), ["prevent","stop"]))
                })
              ])
            ], 2),
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(['row2', _ctx.halfScreen ? 'half-screen' : _ctx.fullScreen ? 'full-screen' : _ctx.mostScreen ? 'most-screen' : ''])
            }, [
              _renderSlot(_ctx.$slots, "stepper-bar")
            ], 2), [
              [_vShow, _ctx.showStepper]
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['modal-body', _ctx.showStepper ? 'hasStepperBar' : ''])
          }, [
            _renderSlot(_ctx.$slots, "body")
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer")
          ])
        ], 2)
      ])
    ])
  ]))
}